import { Outlet, useRouterState } from '@tanstack/react-router'
import { observer } from 'mobx-react-lite'

import { WebApp, WebAppProps } from '@campai/lib-web/app'

import { NotificationsPanel } from './NotificationsPanel'

export const App = observer(({ ...otherProps }: WebAppProps) => {
    const pathname = useRouterState({ select: (state) => state.location.pathname })
    const isFullBleedRoute = pathname === '/create-organization'
    const isHomeRoute = pathname === '/'

    return (
        <WebApp {...otherProps} forceDebugBar>
            <div className="flex h-full min-h-full overflow-hidden">
                <div
                    className={`relative min-w-0 flex-1 ${
                        isFullBleedRoute
                            ? 'overflow-hidden bg-transparent'
                            : `${isHomeRoute ? 'overflow-y-auto lg:overflow-hidden' : 'overflow-y-auto'} bg-[radial-gradient(circle_at_top_left,_rgba(72,187,120,0.12),_transparent_40%),linear-gradient(180deg,#f8fafc_0%,#eef2f7_100%)] dark:bg-[linear-gradient(180deg,var(--color-neutral-950)_0%,var(--color-neutral-900)_100%)]`
                    }`}
                >
                    <main
                        className={
                            isFullBleedRoute
                                ? 'min-h-full w-full'
                                : `mx-auto w-full max-w-6xl px-4 pb-6 pt-4 sm:px-6 sm:py-8 ${isHomeRoute ? 'flex min-h-full flex-col lg:h-full lg:min-h-0' : 'min-h-full'}`
                        }
                    >
                        <Outlet />
                    </main>
                </div>
                <NotificationsPanel />
            </div>
        </WebApp>
    )
})
